import React, { useEffect, useState, useRef } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { connect } from 'react-redux';
import { useNavigate, useParams, Link } from "react-router-dom";
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import { Loader, enumPolicies, enumCalendarEventType, enumSystemPolicyType } from '../../../_metronic/helpers'
import { Button, Row, Col, CardBody, Card, CardFooter } from 'reactstrap';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2'
import Moment from 'react-moment'
import moment from 'moment';
import { Audit } from '../../../_metronic/helpers/components/Audit';
import { Modal } from 'react-bootstrap'
import { AvForm, AvField } from 'availity-reactstrap-validation';
import Resizer from "react-image-file-resizer";
import Dropzone from 'react-dropzone';
import PolicyChecker from '../../../_metronic/helpers/components/PolicyChecker'
import { SystemPolicyChecker } from '../../../_metronic/helpers/components/SystemPolicyChecker';
import Flatpickr from 'react-flatpickr'
import OrderPrint from './orderPrint';
import OrderComponentPrint from './orderComponentPrint';
import OrderStatusFlow from './OrderStatusFlow';
import OrderDetailFields from '../../components/OrderDetailFields';

import CalendarDatePickerComponent from '../../modules/CalendarDatePickerComponent';
import { DigitalSignature } from '../../../_metronic/helpers/digital-signature/DigitalSignature'
import { useAuth } from "../../../app/modules/auth";

import "flatpickr/dist/themes/light.css";
import './OrderStatusFlow.css';
import { OrderConditionType, orderStatusFlow } from './orderStatusFlowData';
import { enumOrderStatusType, enumOrderStatusId } from '../../../_metronic/helpers';

import { getProductList } from '../catalog-management/product/productActions';
import { clearState, getOrder, putOrder, patchOrder, getOrderItems, patchOrderContentStatus, putOrderContent, deleteOrderContent, postOrderContent, getStatus, postStatus, getHistory, getImages, uploadImage, deleteImage, replaceOrderContent } from './orderActions';
import { getCalendarEvent, patchCalendarEvent, postCalendarEvent } from '../calendar-event/calendarEventActions';
import { PRIMARY_COLOR } from '../../../_metronic/helpers/colorConstant';
import { Tooltip } from 'bootstrap';


const Order = (props) => {
    //inputs from url
    const param = useParams();
    const intl = useIntl();
    const navigate = useNavigate();
    const { currentUser } = useAuth();
    const fp = useRef(null);

    const [showModal, setShowModal] = useState(false);
    const [showReplaceModal, setShowReplaceModal] = useState(false);
    const [newContent, setNewContent] = useState({});
    const [replaceContent, setReplaceContent] = useState({});
    const [variantList, setVariantList] = useState([]);
    const [, setPlannedDeliveryDate] = useState(null);
    const [triggerStatus, setTriggerStatus] = useState('');
    const [myFiles, setMyFileList] = useState([])
    const [counter, setCounter] = useState(0)
    const [showEventDatePickerModal, setShowEventDatePickerModal] = useState(false);
    const [installationEvent, setInstallationEvent] = useState(undefined);
    const [comment, setComment] = useState('');

    //inputs from redux
    const {
        order,
        items,
        productList,
        success,
        error,
        loading,
        modalLoading,
        statusList,
        historyList,
        images,
        uploadedImageId
    } = props;

    //actions
    const {
        clearState,
        getOrder,
        putOrder,
        patchOrder,
        getOrderItems,
        patchOrderContentStatus,
        getProductList,
        putOrderContent,
        deleteOrderContent,
        postOrderContent,
        replaceOrderContent,
        getStatus,
        postStatus,
        getHistory,
        getImages,
        uploadImage,
        deleteImage,
        getCalendarEvent,
        patchCalendarEvent,
        postCalendarEvent
    } = props;

    useEffect(() => {
        const promises = [
            getOrder(param.id),
            getOrderItems(param.id),
            getStatus(param.id),
            getHistory(param.id),
            getImages(param.id)
        ];

        if (currentUser && currentUser.policyIds && currentUser.policyIds.some(policy =>
            policy === enumPolicies.ProductRead ||
            policy === enumPolicies.ProductEdit ||
            policy === enumPolicies.ProductWrite)) {
            promises.push(getProductList());
        }

        Promise.all(promises);
        return () => {
            clearState()
        }
    }, []);

    useEffect(() => {
        if (success) {
            toast.success(intl.formatMessage({ id: success }));
        }
    }, [success])

    useEffect(() => {
        if (error) {
            toast.error(error.message);
        }
    }, [error])

    useEffect(() => {
        const getCalendarEventInternal = async (installationEventId) => {
            try {
                const response = await getCalendarEvent(installationEventId)
                if (response && response.isSuccess && response.data) {
                    setInstallationEvent(response.data)
                }
            } catch (error) {
                console.error(error)
            }
        }

        if (order?.installationEventId) {
            getCalendarEventInternal(order.installationEventId);
        }
    }, [order]);

    useEffect(() => {
        if (uploadedImageId) {
            onDeleteFile(uploadedImageId);
        }
    }, [uploadedImageId])

    useEffect(() => {
        // Dispose any existing tooltips first to prevent conflicts
        const existingTooltips = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        existingTooltips.forEach(el => {
            const existingInstance = Tooltip.getInstance(el);
            if (existingInstance) {
                try {
                    existingInstance.dispose();
                } catch (e) {
                    // Ignore errors from tooltips in the middle of animations
                    console.warn('Tooltip disposal warning:', e);
                }
            }
        });

        // Create new tooltips
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl)
        })

        return function cleanup() {
            tooltipList.forEach(t => {
                try {
                    t.dispose();
                } catch (e) {
                    // Ignore errors from tooltips in the middle of animations
                    console.warn('Tooltip disposal warning:', e);
                }
            });
        };
    }, [items, order]);

    const usersBreadcrumbs = [
        {
            title: intl.formatMessage({ id: 'ORDERS.BREADCRUMB.TITLE' }),
            path: '/order-management/orders',
            isSeparator: false,
            isActive: false,
        },
        {
            isSeparator: true,
            isActive: false,
        }
    ]

    const onDropRejected = () => {
        toast.error(intl.formatMessage({ id: 'GENERAL.FILE.INVALID' }));
    }

    const resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                600,
                600,
                "png",
                100,
                0,
                (uri) => {
                    resolve(uri);
                },
                "blob"
            );
        });

    const handleAcceptedFiles = async (filesRaw) => {

        let files = []
        for (let i = 0; i < filesRaw.length; i++) {
            let f = filesRaw[i];

            var image = await resizeFile(f);
            image.name = f.name;

            var counterr = counter + 1;
            setCounter(counterr);

            files.push({
                id: image.name + "-" + counterr,
                file: image,
                name: image.name,
                actionType: 6,
                extension: image.type.split('/')[1],
            })
        }

        files.map(item =>
            Object.assign(item.file, {
                preview: item.file['type'].split('/')[0] === 'image' ? URL.createObjectURL(item.file) : null
            })
        );
        setMyFileList(files)
    };

    const onSaveFile = (id) => {
        var file = myFiles.find(s => s.id == id);
        uploadImage(param.id, file);
    }

    const onDeleteExistFile = (id) => {
        deleteImage(param.id, id)
    }

    const onDeleteFile = (id) => {
        var files = [...myFiles].filter(s => s.id != id);
        setMyFileList(files);
    }

    const onContentCheckChange = (item) => {
        patchOrderContentStatus(param.id, item.id)
        item.checked = !item.checked;
    }

    const openContentModal = (item) => {
        setNewContent({ orderItemId: item.id, orderId: item.orderId, quantity: 1 })
        setShowModal(true);
    }

    const [selectedReplaceVariantId, setSelectedReplaceVariantId] = useState(null);

    const openReplaceContentModal = (content) => {
        setReplaceContent(content);
        setShowReplaceModal(true);
        setSelectedReplaceVariantId(content.variantId || null); // Initialize with existing variant
        if (content.productId) {
            var product = props.productList.find(s => s.id == content.productId);
            if (product && product.variants) {
                setVariantList(product.variants);
            }
        }
    }

    const validation = {
        required: {
            errorMessage: intl.formatMessage({ id: 'VALIDATION.REQUIRED_FIELD' })
        }
    }

    const onPrintContent = (item, content) => {

        const markup = renderToStaticMarkup(
            <OrderComponentPrint
                order={order}
                item={item}
                content={content}
                intl={intl}
            />
        );

        const newTab = window.open('', '_blank');
        newTab.document.write(markup);
        newTab.print();

    }

    const onPrint = () => {

        const markup = renderToStaticMarkup(
            <OrderPrint
                order={order}
                items={items}
                intl={intl}
            />
        );

        const newTab = window.open('', '_blank');
        newTab.document.write(markup);
        newTab.print();

    }

    const handleValidSubmit = (event, values) => {
        var content = {
            orderItemId: newContent.orderItemId,
            orderId: newContent.orderId,
            productId: values.productId,
            variantId: values.variantId,
            quantity: values.quantity,
            additionalAttributesJson: JSON.stringify({
                FreeText: values.description
            })
        };
        putOrderContent(param.id, content);
        onModalClose();
    }

    const handleReplaceValidSubmit = (event, values) => {
        var content = {
            productId: values.productId,
            variantId: (selectedReplaceVariantId && !isNaN(selectedReplaceVariantId)) ? Number(selectedReplaceVariantId) : null,
            quantity: values.quantity,
            additionalAttributesJson: JSON.stringify({
                FreeText: values.description
            })
        };
        replaceOrderContent(param.id, replaceContent.orderItemId, replaceContent.id, content);
        onReplaceModalClose();
    }

    const onProductChange = (e) => {
        setVariantList([]);
        setSelectedReplaceVariantId(null);
        var productId = e.target.value;
        if (productId) {
            var product = productList.find(s => s.id == productId);
            if (product && product.variants) {
                setVariantList(product.variants);
            }
        }
    }

    const onDeleteOrderContent = (id) => {

        Swal.fire({
            title: intl.formatMessage({ id: 'ORDER.QUESTION.SURE' }),
            text: intl.formatMessage({ id: 'ORDER.QUESTION.CONTENT.DELETE' }),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: PRIMARY_COLOR,
            cancelButtonColor: "#dbdfe9",
            confirmButtonText: intl.formatMessage({ id: "ORDER.ANSWER.CONTENT.YES" })
        }).then((result) => {
            if (result.isConfirmed) {
                deleteOrderContent(param.id, id)
            }
        });
    }

    const onModalClose = () => {
        setShowModal(false);
        setNewContent({});
    }

    const onReplaceModalClose = () => {
        setShowReplaceModal(false);
        setReplaceContent({});
    }

    const recalculateContents = (orderItemId) => {
        Swal.fire({
            title: intl.formatMessage({ id: 'ORDER.QUESTION.SURE' }),
            text: intl.formatMessage({ id: "ORDER.QUESTION.CONTENT.CALCULATE" }),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: PRIMARY_COLOR,
            cancelButtonColor: "#dbdfe9",
        }).then((result) => {
            if (result.isConfirmed) {
                postOrderContent(param.id, orderItemId)
            }
        });
    }

    if (!order) {
        return (
            <><Card>
                <CardBody className='text-center'>
                    <i className="bi bi-box fs-5hx text-primary"></i>
                    <Row className='mt-10'></Row>
                    <h1>{intl.formatMessage({ id: "ORDER.FIELD.NOTFOUND" })}</h1>
                    <Row>
                        <Col md={4}>
                        </Col>
                        <Col md={4}>
                            <button onClick={() => navigate("/order-management/orders")} type='submit' className='btn btn-primary mt-10'><span className='fs-2'>{intl.formatMessage({ id: "ORDER.FIELD.GOTOORDERS" })} </span></button>
                        </Col>
                        <Col md={4}>
                        </Col>
                    </Row>
                </CardBody>
            </Card></>
        )
    }

    const onPlannedDeliveryDateClick = ([date]) => {
        if (date) {
            Swal.fire({
                title: intl.formatMessage({ id: "ORDER.QUESTION.SURE" }),
                text: intl.formatMessage({ id: "ORDER.QUESTION.PLANNED.DATE" }),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: PRIMARY_COLOR,
                cancelButtonColor: "#dbdfe9",
            }).then((result) => {
                if (result.isConfirmed) {
                    var x = moment(date).format('YYYY-MM-DD');
                    setPlannedDeliveryDate(x);
                    putOrder(param.id, { plannedDeliveryDate: x })
                }
                else {
                    if (!fp?.current?.flatpickr) return;
                    fp.current.flatpickr.clear(); setPlannedDeliveryDate(null);
                }
            });
        }
    }

    const onStatusChange = (value) => {
        if (value) {
            setTriggerStatus(value)
            Swal.fire({
                title: intl.formatMessage({ id: "ORDER.QUESTION.SURE" }),
                text: intl.formatMessage({ id: "ORDER.QUESTION.STATUS" }),
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: PRIMARY_COLOR,
                cancelButtonColor: "#dbdfe9",
                confirmButtonText: intl.formatMessage({ id: "GENERAL.YES" })
            }).then((result) => {
                if (result.isConfirmed) {
                    postStatus(param.id, value)
                } else {
                    setTriggerStatus('')
                }
            });
        }
    }

    const addComment = () => {
        if (comment == '') return;
        patchOrder(param.id, {
            note: {
                set: true,
                value: comment
            }
        })
        setComment('')
    }

    const onHistoryClick = (history) => {
        if (history.tableName === 'Invoice') {
            navigate(`/order-management/invoices/${history.identifier}`);
        }
    }

    const setSignatureId = (signatureId) => {
        putOrder(param.id, { signatureId: signatureId });
    };

    const renderContentImageLink = (content) => {
        const imageSrc = content?.imageLink ? content.imageLink : '/media/stock/ecommerce/default-product.png';
        return (
            <div className="symbol symbol-circle symbol-50px me-3">
                <div className="symbol-label">
                    <img src={imageSrc} alt={content.productName} className="w-100" />
                </div>
            </div>
        )
    }

    const renderContentItemName = (item, content) => {

        if (content && content.productId > 0) {

            return (
                <div className="d-flex align-items-center">
                    <a target='_blank' href={`/catalog-management/products/${content.productId}/detail`}>
                        {renderContentImageLink(content)}
                    </a>
                    <div className="d-flex flex-column">
                        <a target='_blank' href={`/catalog-management/products/${content.productId}/detail`} className="text-gray-800 text-hover-primary mb-1 fw-bold">{content.productName} - <span className='fw-light'>{content.productCode}</span></a>
                        <span className='fw-bold'>{content.variantName} - <span className='fw-light'>{content.variantCode}</span></span>
                    </div>
                    {
                        content.itemReplaced &&
                        <span className="btn btn-sm btn-icon btn-light-warning ms-2" data-bs-toggle="tooltip" title={intl.formatMessage({ id: "ORDER.CONTENT.MODIFIED.TOOLTIP" })}>
                            <i className="ki-duotone ki-arrows-circle fs-3">
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </span>
                    }
                </div>
            )
        }

        return (
            <>
                {item.name}
            </>
        )

    }

    const renderContentModal = () => {
        return (
            <Modal size="lg" centered show={showModal} onHide={() => setShowModal(!showModal)}>
                <Modal.Header closeButton>
                    <Modal.Title>{intl.formatMessage({ id: "ORDER.FIELD.ADDCONTENT" })}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AvForm id="add-content-form" key={1} onValidSubmit={handleValidSubmit}>
                        <Row>
                            <Col>
                                <AvField type="select" name="productId" label={intl.formatMessage({ id: "ORDER.FIELD.PRODUCT" })} validate={validation} value={newContent && newContent.productId} onChange={(e) => onProductChange(e)}>
                                    <option value=''>{intl.formatMessage({ id: "GENERAL.SELECT" })}</option>
                                    {productList && productList.map((item, index) => {
                                        return (
                                            <option key={`products_${index}`} value={item.id}>{item.name} ({item.sku})</option>
                                        )
                                    })}
                                </AvField>
                            </Col>
                            <Col>
                                <AvField type="select" name="variantId" label={intl.formatMessage({ id: "ORDER.FIELD.VARIANT" })} validate={validation} value={newContent && newContent.variantId}>
                                    <option value=''>{intl.formatMessage({ id: "GENERAL.SELECT" })}</option>
                                    {variantList.map((item, index) => {
                                        return (
                                            <option key={`variants_${index}`} value={item.id}>{item.name} ({item.code})</option>
                                        )
                                    })}
                                </AvField>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <AvField name="quantity" label={intl.formatMessage({ id: "ORDER.FIELD.QUANTITY" })} type="number" min={1} value={newContent && newContent.quantity} validate={validation} />
                            </Col>
                            <Col>
                                <AvField name="description" label={intl.formatMessage({ id: "ORDER.FIELD.DESCRIPTION" })} type="textarea" rows={4} value={newContent && newContent.description} validate={validation} />
                            </Col>
                        </Row>
                    </AvForm>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-light" onClick={() => onModalClose()}>{intl.formatMessage({ id: "GENERAL.CLOSE" })}</button>
                    <Button color="success" type="submit" form="add-content-form">{intl.formatMessage({ id: "GENERAL.SUBMIT" })}</Button>
                </Modal.Footer>
                {(modalLoading || loading) && <Loader />}
            </Modal>
        )
    }

    const renderReplaceContentModal = () => {
        // Parse the additional attributes to get details
        const detail = replaceContent?.additionalAttributesJson ? JSON.parse(replaceContent.additionalAttributesJson) : {};

        return (
            <Modal size="lg" centered show={showReplaceModal} onHide={() => setShowReplaceModal(!showReplaceModal)}>
                <Modal.Header closeButton>
                    <Modal.Title>{intl.formatMessage({ id: "ORDER.FIELD.REPLACECONTENT" })}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* Display current item being replaced */}
                    {replaceContent && replaceContent.productId && (
                        <div className="mb-7 p-5 bg-light-primary rounded">
                            <h5 className="mb-4">{intl.formatMessage({ id: "ORDER.FIELD.CURRENTITEM" }) || "Current Item to Replace"}</h5>
                            <div className="d-flex align-items-start">
                                {renderContentImageLink(replaceContent)}
                                <div className="flex-grow-1 ms-3">
                                    <div className="d-flex flex-column mb-3">
                                        <span className="text-gray-800 fw-bold fs-6">{replaceContent.productName} - <span className='fw-light'>{replaceContent.productCode}</span></span>
                                        <span className='fw-bold fs-7'>{replaceContent.variantName} - <span className='fw-light'>{replaceContent.variantCode}</span></span>
                                        <span className='fw-semibold text-muted fs-7 mt-1'>{intl.formatMessage({ id: "ORDER.FIELD.QUANTITY" })}: {replaceContent.quantity}</span>
                                    </div>
                                    {/* Display details */}
                                    <div className="fs-7">
                                        <OrderDetailFields detail={detail} intl={intl} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <AvForm
                        id="replace-content-form"
                        key={replaceContent?.id}
                        onValidSubmit={handleReplaceValidSubmit}
                        model={{
                            productId: replaceContent?.productId,
                            variantId: replaceContent?.variantId,
                            quantity: replaceContent?.quantity,
                            description: detail?.FreeText
                        }}
                    >
                        <Row>
                            <Col>
                                <AvField type="select" name="productId" label={intl.formatMessage({ id: "ORDER.FIELD.PRODUCT" })} validate={validation} onChange={(e) => onProductChange(e)}>
                                    <option value=''>{intl.formatMessage({ id: "GENERAL.SELECT" })}</option>
                                    {productList && productList.map((item, index) => {
                                        return (
                                            <option key={`products_${index}`} value={item.id}>
                                                {item.name} ({item.sku}){item.optionValueName ? ` - ${item.optionValueName}` : ''}
                                            </option>
                                        )
                                    })}
                                </AvField>
                            </Col>
                            <Col>
                                <AvField type="select"
                                    name="variantId"
                                    label={intl.formatMessage({ id: "ORDER.FIELD.VARIANT" })}
                                    onChange={(e) => setSelectedReplaceVariantId(e.target.value)}
                                >
                                    <option value=''>{intl.formatMessage({ id: "GENERAL.SELECT" })}</option>
                                    {variantList.map((item, index) => {
                                        return (
                                            <option key={`variants_${index}`} value={item.id}>{item.name} ({item.code})</option>
                                        )
                                    })}
                                </AvField>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <AvField name="quantity" label={intl.formatMessage({ id: "ORDER.FIELD.QUANTITY" })} type="number" min={1} validate={validation} />
                            </Col>
                            <Col>
                                <AvField
                                    name="description"
                                    label={intl.formatMessage({ id: "ORDER.FIELD.DESCRIPTION" })}
                                    type="textarea"
                                    rows={4}
                                    validate={{
                                        required: {
                                            value: !selectedReplaceVariantId,
                                            errorMessage: intl.formatMessage({ id: 'VALIDATION.REQUIRED_FIELD' })
                                        }
                                    }}
                                />
                            </Col>
                        </Row>
                    </AvForm>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-light" onClick={() => onReplaceModalClose()}>{intl.formatMessage({ id: "GENERAL.CLOSE" })}</button>
                    <Button color="success" type="submit" form="replace-content-form">{intl.formatMessage({ id: "GENERAL.SUBMIT" })}</Button>
                </Modal.Footer>
                {(modalLoading || loading) && <Loader />}
            </Modal>
        )
    }

    const renderContentItem = (item) => {
        if (item && item.contents && item.contents.length > 0) {
            return (
                <tr key={`item_content_${item.id}`}>
                    <td colSpan={8}>
                        <table className="table table-row-dashed table-row-gray-500 gy-5 gs-5 mb-0">
                            <thead>
                                <tr className="fw-bolder fs-5 text-gray-800 border-bottom border-gray-800">
                                    <th>{intl.formatMessage({ id: "ORDER.FIELD.PRODUCTNAME" })}</th>
                                    <th>{intl.formatMessage({ id: "ORDER.FIELD.QUANTITY" })}</th>
                                    <th>{intl.formatMessage({ id: "ORDER.FIELD.DETAIL" })}</th>
                                    <PolicyChecker policies={[enumPolicies.OrderAdmin, enumPolicies.OrderPersonnel]}>
                                        <th className='text-center'>{intl.formatMessage({ id: "ORDER.FIELD.READY" })}</th>
                                        <th className='text-center'>{intl.formatMessage({ id: "ORDER.FIELD.ACTION" })}</th>
                                    </PolicyChecker>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    item.contents && item.contents.map((content) => {
                                        var detail = content.additionalAttributesJson != '' && JSON.parse(content.additionalAttributesJson);
                                        return (
                                            <tr key={`item_content_tr_${content.id}`} className='py-5 fw-semibold vertical-middle fs-6'>
                                                <td width={"25%"}>
                                                    {renderContentItemName(item, content)}
                                                </td>
                                                <td width={"5%"} style={{ textAlign: "-webkit-center" }}>{content.quantity}</td>
                                                <td width={"30%"} style={{ minWidth: '200px' }}>
                                                    <OrderDetailFields detail={detail} intl={intl} />
                                                </td>

                                                <PolicyChecker policies={[enumPolicies.OrderAdmin, enumPolicies.OrderPersonnel]}>
                                                    <td width={"10%"} className='text-center'>
                                                        <div className="form-check form-check-custom form-check-solid d-inline-block">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                checked={content.checked}
                                                                disabled={order?.orderStatus !== enumOrderStatusId.Approved && order?.orderStatus !== enumOrderStatusId.Preparing}
                                                                onChange={() => onContentCheckChange(content)}
                                                                style={{ transform: 'scale(1.5)', cursor: 'pointer' }}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td width={"10%"}>
                                                        <div className='d-flex justify-content-end'>
                                                            <button type="button" className="btn btn-sm btn-icon btn-light" onClick={() => onPrintContent(item, content)} data-bs-toggle="tooltip" title={intl.formatMessage({ id: "GENERAL.PRINT" })}>
                                                                <i className="ki-duotone ki-printer fs-3">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                    <span className="path3"></span>
                                                                    <span className="path4"></span>
                                                                    <span className="path5"></span>
                                                                </i>
                                                            </button>
                                                            <PolicyChecker policies={[enumPolicies.OrderAdmin]}>
                                                                <button type="button" className="btn btn-sm btn-icon btn-light-primary ms-2" onClick={() => openReplaceContentModal(content)} data-bs-toggle="tooltip" title={intl.formatMessage({ id: "ORDER.FIELD.REPLACECONTENT" })}>
                                                                    <i className="ki-duotone ki-arrows-circle fs-3">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </button>
                                                                <button type="button" className="btn btn-sm btn-icon btn-light-danger ms-2" onClick={() => onDeleteOrderContent(content.id)} data-bs-toggle="tooltip" title={intl.formatMessage({ id: "GENERAL.DELETE" })}>
                                                                    <i className="ki-duotone ki-trash fs-3">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                        <span className="path3"></span>
                                                                        <span className="path4"></span>
                                                                        <span className="path5"></span>
                                                                    </i>
                                                                </button>
                                                            </PolicyChecker>
                                                            <Audit className="ms-2" table="OrderContent" identifier={content.id} />
                                                        </div>
                                                    </td>
                                                </PolicyChecker>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </td>
                </tr>
            )
        }
        return;
    }

    const renderSummary = () => {
        return (
            <div className="tab-pane fade show active" id="kt_ecommerce_sales_order_summary" role="tab-panel">
                <div className="d-flex flex-column gap-7 gap-lg-10">

                    <div className="card card-flush py-4 flex-row-fluid overflow-hidden">
                        <div className="card-header">
                            <div className="card-title">
                                <h2>{intl.formatMessage({ id: "ORDER.FIELD.ITEMS" })} #{order.id}</h2>
                            </div>
                            <div className='card-toolbar'>
                                <PolicyChecker policies={[enumPolicies.OrderAdmin, enumPolicies.OrderPersonnel]}>
                                    <div className="d-flex flex-end rounded-3 mt-5">
                                        <i className={`ki-duotone ki-printer fs-3x`} onClick={() => onPrint()}>
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                            <span className="path3"></span>
                                            <span className="path4"></span>
                                            <span className="path5"></span>
                                        </i>
                                    </div>
                                </PolicyChecker>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            <div className="table-responsive">
                                <table className="table table-rounded border gy-7 gs-7">
                                    <thead>
                                        <tr className="fw-bolder fs-5 text-gray-800 border-bottom border-gray-2000">
                                            <th>{intl.formatMessage({ id: "ORDER.FIELD.NAME" })}</th>
                                            <th>{intl.formatMessage({ id: "ORDER.FIELD.DETAIL" })}</th>
                                            <PolicyChecker policies={[enumPolicies.OrderAdmin, enumPolicies.OrderDealer]}>
                                                <th>{intl.formatMessage({ id: "ORDER.FIELD.PRICE" })}</th>
                                                <th>{intl.formatMessage({ id: "ORDER.FIELD.QUANTITY" })}</th>
                                                <th>{intl.formatMessage({ id: "ORDER.FIELD.TOTALPRICE" })}</th>
                                                <th>{intl.formatMessage({ id: "ORDER.FIELD.VAT" })} %</th>
                                                <th>{intl.formatMessage({ id: "ORDER.FIELD.VAT" })} </th>
                                            </PolicyChecker>
                                            <PolicyChecker policies={[enumPolicies.OrderAdmin, enumPolicies.OrderPersonnel]}>
                                                <th className='text-center'>{intl.formatMessage({ id: "ORDER.FIELD.ACTION" })}</th>
                                            </PolicyChecker>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            items && items.map((item) => {
                                                var detail = JSON.parse(item.orderItemAttributesJson);
                                                return (
                                                    <>
                                                        <tr key={`item_tr_${item.id}`} className='bg-gray-100 py-5 fw-semibold vertical-middle border-bottom border-top border-gray-300 fs-6'>
                                                            <td width={"20%"}>
                                                                {item.name}
                                                            </td>
                                                            <td width={"25%"} style={{ minWidth: '200px' }}>
                                                                <OrderDetailFields detail={detail} intl={intl} />
                                                            </td>
                                                            <PolicyChecker policies={[enumPolicies.OrderAdmin, enumPolicies.OrderDealer]}>
                                                                <td width={"10%"}>€ {Number(item.price).toFixed(2)}</td>
                                                                <td width={"10%"}>{item.quantity}</td>
                                                                <td width={"10%"}>€ {Number(item.totalPrice).toFixed(2)}</td>
                                                                <td width={"10%"}>{!item.isDiscountItem ? `${item.vat}%` : ``}</td>
                                                                <td width={"10%"}>{!item.isDiscountItem ? `€ ${Number(item.totalVatPrice).toFixed(2)}` : ``}</td>
                                                            </PolicyChecker>
                                                            <PolicyChecker policies={[enumPolicies.OrderAdmin, enumPolicies.OrderPersonnel]}>
                                                                <td width={"5%"} className="text-end">
                                                                    <div className='d-flex justify-content-end'>
                                                                        {!item.isDiscountItem && (
                                                                            <SystemPolicyChecker policyId={enumSystemPolicyType.OrderContent}>
                                                                                <PolicyChecker policies={[enumPolicies.OrderAdmin]}>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-sm btn-icon btn-light me-2"
                                                                                        data-bs-toggle="tooltip"
                                                                                        title={intl.formatMessage({ id: "ORDER.FIELD.ADDCONTENT" })}
                                                                                        onClick={() => openContentModal(item)}
                                                                                    >
                                                                                        <i className="ki-duotone ki-plus-circle fs-3">
                                                                                            <span className="path1"></span>
                                                                                            <span className="path2"></span>
                                                                                            <span className="path3"></span>
                                                                                        </i>
                                                                                    </button>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-sm btn-icon btn-light me-2"
                                                                                        data-bs-toggle="tooltip"
                                                                                        title={intl.formatMessage({ id: "ORDER.FIELD.RECALCULATECONTENTS" })}
                                                                                        onClick={() => recalculateContents(item.id)}
                                                                                    >
                                                                                        <i className="ki-duotone ki-arrows-circle fs-3">
                                                                                            <span className="path1"></span>
                                                                                            <span className="path2"></span>
                                                                                        </i>
                                                                                    </button>
                                                                                </PolicyChecker>
                                                                            </SystemPolicyChecker>
                                                                        )}
                                                                        <Audit table="OrderItem" identifier={item.id} />
                                                                    </div>
                                                                </td>
                                                            </PolicyChecker>
                                                        </tr >
                                                        <SystemPolicyChecker policyId={enumSystemPolicyType.OrderContent}>
                                                            {renderContentItem(item)}
                                                        </SystemPolicyChecker>
                                                    </>
                                                )
                                            })
                                        }

                                        <PolicyChecker policies={[enumPolicies.OrderAdmin, enumPolicies.OrderDealer]}>
                                            <tr className="py-5 border-bottom border-top vertical-middle  fs-4 vertical-middle">
                                                <td colSpan={3}></td>
                                                <td colSpan={3}>{intl.formatMessage({ id: "ORDER.FIELD.SUBTOTALEXVAT" })} <br></br> {intl.formatMessage({ id: "ORDER.FIELD.VAT" })} </td>
                                                <td>
                                                    € {items && items.map(s => s.subTotalPrice).reduce((a, b) => a + b, 0).toFixed(2)}
                                                    <br></br>
                                                    € {items && items.map(s => s.totalVatPrice).reduce((a, b) => a + b, 0).toFixed(2)}
                                                </td>
                                                <td ></td>
                                            </tr>

                                            <tr className="py-5 fw-bold  border-bottom vertical-middle border-gray-500 fs-3 vertical-middle">
                                                <td colSpan={3}></td>
                                                <td colSpan={3}>{intl.formatMessage({ id: "ORDER.FIELD.TOTAL" })}</td>
                                                <td>€ {items && items.map(s => s.totalPrice).reduce((a, b) => a + b, 0).toFixed(2)}</td>
                                                <td></td>
                                            </tr>
                                        </PolicyChecker>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <PolicyChecker policies={[enumPolicies.SignatureRead, enumPolicies.SignatureWrite]}>
                        <div className="card card-flush py-4 flex-row-fluid overflow-hidden">
                            <DigitalSignature
                                intl={intl}
                                signatureId={order.signatureId}
                                canEdit={order.orderStatus === enumOrderStatusId.Ready}
                                customerId={order.customerId}
                                userId={order.userId}
                                onSignatureIdChange={setSignatureId}
                            />
                        </div>
                    </PolicyChecker>
                </div>
            </div>
        )
    }

    const renderImages = () => {

        return (
            <div className="tab-pane fade" id="kt_ecommerce_sales_order_images" role="tabpanel">
                <div className='card'>
                    <div className="card-body">

                        <Dropzone
                            onDrop={acceptedFiles => handleAcceptedFiles(acceptedFiles)}
                            onDropRejected={onDropRejected}
                            accept={['image/png', 'image/jpg', 'image/jpeg']}
                            multiple={true}
                            maxSize={20000000}>
                            {({ getRootProps, getInputProps }) => {
                                return (
                                    <>
                                        <div className="dropzone dz-clickable">
                                            <div className="dz-message needsclick" {...getRootProps()}>
                                                <input {...getInputProps()} />
                                                <i className="ki-duotone ki-file-up fs-3x text-primary"><span className="path1"></span><span className="path2"></span></i>
                                                <div className="ms-4">
                                                    <h3 className="fs-5 fw-bold text-gray-900 mb-1">{intl.formatMessage({ id: 'ORDER.IMAGE.UPLOAD' })} </h3>
                                                    <span className="fs-7 fw-semibold text-primary opacity-75">{intl.formatMessage({ id: 'ORDER.IMAGE.MAX' })}</span>
                                                    <br></br>
                                                    <span className="fs-7 fw-semibold text-primary opacity-75">{intl.formatMessage({ id: 'ORDER.IMAGE.FORMATS' })}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )
                            }}
                        </Dropzone>

                        <div className={"dropzone-previews mt-3"} id="file-previews">
                            {myFiles.map((f, i) => {
                                return (
                                    <Card
                                        className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                        key={i + '-file'}>
                                        <div className="p-2">
                                            <Row className="align-items-center">
                                                <Col className="col-auto">
                                                    <img
                                                        width={250}
                                                        data-dz-thumbnail=""
                                                        className="avatar-sm rounded bg-light"
                                                        alt={f.file.name}
                                                        src={f.file.preview}
                                                    />
                                                </Col>
                                                <Col className="pl-0">
                                                    <Link to="#" className="text-muted font-weight-bold">
                                                        {f.file.name}
                                                    </Link>
                                                </Col>

                                                <Col className="col-auto">
                                                    <Button
                                                        className="btn btn-icon btn-circle btn-active-success"
                                                        onClick={() => onSaveFile(f.id)}>
                                                        <i className="ki-duotone ki-check-circle fs-2x">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                            <span className="path3"></span>
                                                        </i>
                                                    </Button>
                                                </Col>

                                                <Col className="col-auto">
                                                    <Button
                                                        className="btn btn-icon btn-circle btn-active-danger"
                                                        onClick={() => onDeleteFile(f.id)}>
                                                        <i className="ki-duotone ki-cross-circle fs-2x">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Card>
                                );
                            })}
                        </div>




                    </div>
                </div>

                <div className='card mt-20'>
                    <div className='card-header'>
                        <h3 className="card-title">{intl.formatMessage({ id: "ORDER.FIELD.IMAGES" })}</h3>
                    </div>
                    <div className='card-body'>
                        <div className='row'>

                            {images && images.map((item, index) => {
                                return (
                                    <div key={item.id} className='col-md-3'>
                                        <div className="card h-100 ">
                                            <Audit table="ProductImage" identifier={item.id} />
                                            <div className="card-body d-flex justify-content-center text-center flex-column p-8">
                                                <a href={item.link} download={true} target="_blank" className="text-gray-800 text-hover-primary d-flex flex-column">
                                                    <div className="symbol symbol-150px mb-5">
                                                        <img src={item.link} alt="" />
                                                    </div>
                                                    <div className="fs-7 fw-semibold text-gray-500"><Moment>{item.createdOn}</Moment> </div>
                                                </a>


                                                <div className="fs-7 fw-semibold text-gray-500  mt-5">
                                                    <button type="button" className="btn btn-icon btn-flex btn-active-light-danger w-30px h-30px me-3" onClick={() => onDeleteExistFile(item.id)}>
                                                        <i className="ki-duotone ki-trash fs-3">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                            <span className="path3"></span>
                                                            <span className="path4"></span>
                                                            <span className="path5"></span>
                                                        </i>
                                                    </button>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>

        )
    }

    const renderDocuments = () => {
        if (order?.invoice || order?.quote) {
            return (
                <>
                    <div className="separator my-10"></div>
                    <div className="card-header">
                        <div className="card-title">
                            <h2>{intl.formatMessage({ id: "ORDER.FIELD.DOCUMENTS" })}</h2>
                        </div>
                    </div>
                    <div className="card-body pt-0">
                        <div className="table-responsive">
                            <table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
                                <tbody className="fw-semibold text-gray-600">
                                    {
                                        order.invoice &&
                                        <tr>
                                            <td className="text-muted">
                                                <div className="d-flex align-items-center">
                                                    <i className="ki-duotone ki-devices fs-2 me-2">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                        <span className="path3"></span>
                                                        <span className="path4"></span>
                                                        <span className="path5"></span>
                                                    </i>
                                                    {intl.formatMessage({ id: "ORDER.FIELD.INVOICE" })}
                                                </div>
                                            </td>
                                            <td className="fw-bold text-end">
                                                <div className="d-flex align-items-center justify-content-end">
                                                    <button
                                                        onClick={() => navigate(`/order-management/invoices/${order.invoice.id}`)}
                                                        className="btn btn-link text-gray-600 text-hover-primary"
                                                    >
                                                        #{order.invoice.invoiceNr ? order.invoice.invoiceNr : '-'}
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                    {
                                        order.quote &&
                                        <tr>
                                            <td className="text-muted">
                                                <div className="d-flex align-items-center">
                                                    <i className="ki-duotone ki-devices fs-2 me-2">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                        <span className="path3"></span>
                                                        <span className="path4"></span>
                                                        <span className="path5"></span>
                                                    </i>
                                                    {intl.formatMessage({ id: "ORDER.FIELD.QUOTE" })}
                                                </div>
                                            </td>
                                            <td className="fw-bold text-end">
                                                <div className="d-flex align-items-center justify-content-end">
                                                    <button
                                                        onClick={() => navigate(`/order-management/quotes/${order.quote.id}`)}
                                                        className="btn btn-link text-gray-600 text-hover-primary"
                                                    >
                                                        #{order?.quote?.quoteNr ? order.quote.quoteNr : '-'}
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </>
            );
        }

        return null;
    }

    const renderHistory = () => {
        return (
            <div className="tab-pane fade" id="kt_ecommerce_sales_order_history" role="tab-panel">
                <div className="d-flex flex-column gap-7 gap-lg-10">
                    <div className="card card-flush py-4 flex-row-fluid">
                        <div className="card-header">
                            <div className="card-title">
                                <h2>{intl.formatMessage({ id: "ORDER.FIELD.HISTORY" })}</h2>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            <div className="table-responsive">
                                <table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
                                    <thead>
                                        <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                            <th className="min-w-100px">{intl.formatMessage({ id: "ORDER.FIELD.USER" })}</th>
                                            <th className="min-w-175px">{intl.formatMessage({ id: "ORDER.FIELD.COMMENT" })}</th>
                                            <th className="min-w-100px">{intl.formatMessage({ id: "ORDER.FIELD.DATE" })}</th>
                                        </tr>
                                    </thead>
                                    <tbody className="fw-semibold text-gray-600">

                                        {historyList && historyList.map((history, index) => {
                                            return (
                                                <tr key={`history_row_${index}`}>
                                                    <td>{history.userName}</td>
                                                    <td
                                                        className={`${history.tableName === "Invoice" ? "cursor-pointer hover:text-primary-light" : ""}`}
                                                        onClick={() => onHistoryClick(history)}
                                                        style={{ whiteSpace: 'pre-line' }}
                                                    >
                                                        {history.fieldName}
                                                    </td>
                                                    <td><Moment>{history.date}</Moment></td>
                                                </tr>
                                            )
                                        })}

                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <CardFooter className="p-5">
                            <div className="input-group">
                                <textarea
                                    className='form-control'
                                    rows={1}
                                    onChange={(e) => setComment(e.target.value)}
                                    value={comment}
                                    placeholder={intl.formatMessage({ id: "ORDER.HISTORY.ADD_NOTE" })}
                                    style={{ resize: 'none' }}
                                />
                                <button
                                    className="btn btn-primary"
                                    onClick={() => addComment()}
                                    disabled={!comment.trim()}
                                >
                                    <i className="ki-duotone ki-send fs-2">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </button>
                            </div>
                        </CardFooter>
                    </div>
                </div>
            </div>
        )
    }

    const renderEventDatePicker = () => {
        var startDate = installationEvent?.start && moment(new Date(installationEvent.start).toISOString()).format('DD/MM/YYYY, HH:mm');
        var endDate = installationEvent?.end && moment(new Date(installationEvent.end).toISOString()).format('DD/MM/YYYY, HH:mm');
        return (
            <input
                type="text"
                value={installationEvent && `${startDate}${installationEvent.end && ' - '}${installationEvent.end && endDate}`}
                className="form-control text-end form-control-solid cursor-pointer"
                readOnly
                placeholder={intl.formatMessage({ id: "ORDER.FIELD.INSTALLATIONDATE.PLACEHOLDER" })}
                onClick={() => {
                    setShowEventDatePickerModal(true)
                }}
            />
        )
    }

    const renderCalendarDataPickerModal = () => {
        var startDate = installationEvent?.start && moment(new Date(installationEvent.start).toISOString()).format('YYYY-MM-DDTHH:mm')
        var endDate = installationEvent?.end && moment(new Date(installationEvent.end).toISOString()).format('YYYY-MM-DDTHH:mm')
        return (
            <CalendarDatePickerComponent
                show={showEventDatePickerModal}
                onHide={() => setShowEventDatePickerModal(false)}
                onSubmit={handleCalendarPickerSubmit}
                initialData={{
                    title: installationEvent !== undefined && installationEvent !== null ? installationEvent.title :
                        order.user !== undefined ? `${order.user.name} ${order.user.surname}` :
                            order.customer !== undefined ? `${order.customer.name} ${order.customer.surname}` : '',
                    description: installationEvent !== undefined && installationEvent !== null ? installationEvent.description : '',
                    startDate: installationEvent !== undefined && installationEvent !== null && installationEvent.start !== undefined ? startDate : '',
                    endDate: installationEvent !== undefined && installationEvent !== null && installationEvent.end !== undefined ? endDate : ''
                }}
            />
        )
    }

    const handleCalendarPickerSubmit = async (formData) => {
        if (order && order.installationEventId) {
            var response = await patchCalendarEvent(order.installationEventId, {
                start: {
                    set: true,
                    value: formData.startDate
                },
                end: {
                    set: true,
                    value: formData.endDate
                },
                title: {
                    set: true,
                    value: formData.title
                },
                description: {
                    set: true,
                    value: formData.description
                },
                eventIdentifier: {
                    set: true,
                    value: enumCalendarEventType.OrderInstallation
                },
                eventSourceId: {
                    set: true,
                    value: order.id
                }
            })
            if (response.isSuccess) {
                await putOrder(order.id, { installationEventId: response.data.id })
                setInstallationEvent({
                    start: formData.startDate,
                    end: formData.endDate,
                    title: formData.title,
                    description: formData.description,
                    eventIdentifier: enumCalendarEventType.OrderInstallation,
                    eventSourceId: order.id
                })
            }
        } else {
            var response = await postCalendarEvent({
                start: formData.startDate,
                end: formData.endDate,
                title: formData.title,
                description: formData.description,
                eventIdentifier: enumCalendarEventType.OrderInstallation,
                eventSourceId: order.id
            })
            if (response.isSuccess) {
                await putOrder(order.id, { installationEventId: response.data.id })
                setInstallationEvent({
                    start: formData.startDate,
                    end: formData.endDate,
                    title: formData.title,
                    description: formData.description,
                    eventIdentifier: enumCalendarEventType.OrderInstallation,
                    eventSourceId: order.id
                })
            }
        }
    }

    return (

        <>
            <PageTitle breadcrumbs={usersBreadcrumbs}>{intl.formatMessage({ id: 'ORDERS.BREADCRUMB.DESCRIPTION' })}</PageTitle>

            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-xxl">
                    <div className="d-flex flex-column gap-7 gap-lg-10">
                        {order && statusList && <OrderStatusFlow
                            currentStatus={order.orderStatusName}
                            nextStates={statusList}
                            onStateClick={onStatusChange}
                            conditions={[
                                {
                                    type: OrderConditionType.AllItemsReady,
                                    status: enumOrderStatusType.Preparing,
                                    isMet: items && items.length > 0 && items.every(i => !i.contents || i.contents.every(c => c.checked))
                                },
                                {
                                    type: OrderConditionType.DigitalSignature,
                                    status: enumOrderStatusType.Ready,
                                    isMet: !!order.signatureId
                                },
                                {
                                    type: OrderConditionType.PhotosAdded,
                                    status: enumOrderStatusType.Ready,
                                    isMet: images && images.length > 0
                                }
                            ]}
                        />}
                        <div className="d-flex flex-wrap flex-stack gap-5 gap-lg-10">
                            <ul className="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semibold mb-lg-n2 me-auto">
                                <li className="nav-item">
                                    <a className="nav-link text-active-primary pb-4 active" data-bs-toggle="tab" href="#kt_ecommerce_sales_order_summary">{intl.formatMessage({ id: "ORDER.FIELD.SUMMARY" })}</a>
                                </li>
                                <PolicyChecker policies={[enumPolicies.OrderAdmin, enumPolicies.OrderPersonnel]}>
                                    <li className="nav-item">
                                        <a className="nav-link text-active-primary pb-4" data-bs-toggle="tab" href="#kt_ecommerce_sales_order_images">
                                            <span className="position-relative">
                                                {intl.formatMessage({ id: "ORDER.FIELD.IMAGES" })}
                                                {images && images.length > 0 && <span className="bullet bullet-dot bg-danger position-absolute top-0 start-100 translate-middle-y ms-1"></span>}
                                            </span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link text-active-primary pb-4" data-bs-toggle="tab" href="#kt_ecommerce_sales_order_history">{intl.formatMessage({ id: "ORDER.FIELD.HISTORY" })}</a>
                                    </li>
                                </PolicyChecker>
                            </ul>
                        </div>
                        <div className="d-flex flex-column flex-xl-row gap-7 gap-lg-10">
                            <div className="card card-flush py-4 flex-row-fluid">
                                <div className="card-header">
                                    <div className="card-title">
                                        <h2>{intl.formatMessage({ id: "ORDER.FIELD.ORDERDETAILS" })} (#{order.id}{order.reference ? ` / ${order.reference}` : ""}) </h2>
                                    </div>
                                    <div className='card-actions'>
                                        <PolicyChecker policies={[enumPolicies.OrderAdmin, enumPolicies.OrderPersonnel]}>
                                            <Audit className="text-end" table="Order" identifier={order.id} />
                                        </PolicyChecker>
                                    </div>
                                </div>
                                <div className="card-body pt-0">
                                    <div className="table-responsive">
                                        <table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
                                            <tbody className="fw-semibold text-gray-600">
                                                <tr>
                                                    <td className="text-muted">
                                                        <div className="d-flex align-items-center">
                                                            <i className="ki-duotone ki-calendar fs-2 me-2">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>{intl.formatMessage({ id: "ORDER.FIELD.CREATEDATE" })}</div>
                                                    </td>
                                                    <td className="fw-bold text-end"><Moment>{order.createdOn}</Moment></td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted">
                                                        <div className="d-flex align-items-center">
                                                            <i className="ki-duotone ki-calendar fs-2 me-2">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>{intl.formatMessage({ id: "ORDER.FIELD.WISHDATE" })}</div>
                                                    </td>
                                                    <td className="fw-bold text-end">{moment(order.wishedDeliveryDate).format('DD-MM-YYYY')}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted">
                                                        <div className="d-flex align-items-center">
                                                            <i className="ki-duotone ki-calendar fs-2 me-2">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>{intl.formatMessage({ id: "ORDER.FIELD.PLANNEDDATE" })}</div>
                                                    </td>
                                                    <PolicyChecker policies={[enumPolicies.OrderAdmin]}>
                                                        <td className="fw-bold text-end">
                                                            <Flatpickr ref={fp}
                                                                onChange={onPlannedDeliveryDateClick}
                                                                options={{
                                                                    dateFormat: "d-m-Y",
                                                                    defaultDate: [order && moment(order.plannedDeliveryDate).format('DD-MM-YYYY')]
                                                                }}
                                                                className='form-control text-end form-control-solid'
                                                                placeholder={intl.formatMessage({ id: "ORDER.FIELD.PLANNEDDATE.PLACEHOLDER" })}
                                                            />
                                                        </td>
                                                    </PolicyChecker>
                                                    <PolicyChecker policies={[enumPolicies.OrderPersonnel, enumPolicies.OrderDealer]}>
                                                        <td className="fw-bold text-end">{moment(order.plannedDeliveryDate).format('DD-MM-YYYY')}</td>
                                                    </PolicyChecker>
                                                </tr>
                                                <PolicyChecker policies={[enumPolicies.OrderAdmin]}>
                                                    <tr>
                                                        <td className="text-muted">
                                                            <div className="d-flex align-items-center">
                                                                <i className="ki-duotone ki-calendar fs-2 me-2">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>{intl.formatMessage({ id: "ORDER.FIELD.INSTALLATIONDATE" })}</div>
                                                        </td>
                                                        <td className="fw-bold text-end">
                                                            {renderEventDatePicker()}
                                                        </td>
                                                    </tr>
                                                </PolicyChecker>
                                                <tr>
                                                    <td className="text-muted">
                                                        <div className="d-flex align-items-center">
                                                            <i className="ki-duotone ki-wallet fs-2 me-2">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                                <span className="path3"></span>
                                                                <span className="path4"></span>
                                                            </i>{intl.formatMessage({ id: "ORDER.FIELD.PAYMENTMETHOD" })}</div>
                                                    </td>
                                                    <td className="fw-bold text-end">{order.paymentMethodName}</td>
                                                </tr>
                                                {order.orderNote && (
                                                    <tr>
                                                        <td className="text-muted align-top">
                                                            <div className="d-flex align-items-center">
                                                                <i className="ki-duotone ki-note-2 fs-2 me-2">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                                <div className="position-relative">
                                                                    {intl.formatMessage({ id: "CHECKOUTSUMMARY.FIELD.NOTE" })}
                                                                    <span className="bullet bullet-dot bg-danger h-6px w-6px position-absolute translate-middle top-0 start-100 animation-blink ms-2"></span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="fw-bold text-end">
                                                            <div className="bg-gray-100 rounded p-2 d-inline-block text-start" style={{ whiteSpace: 'pre-wrap', width: '100%', maxHeight: '100px', overflowY: 'auto' }}>
                                                                {order.orderNote}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="card card-flush py-4 flex-row-fluid">
                                <div className="card-header">
                                    <div className="card-title">
                                        <h2>{intl.formatMessage({ id: "ORDER.FIELD.CUSTOMERDETAILS" })}</h2>
                                    </div>
                                </div>
                                <div className="card-body pt-0">
                                    <div className="table-responsive">
                                        <table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
                                            <tbody className="fw-semibold text-gray-600">
                                                <tr>
                                                    <td className="text-muted">
                                                        <div className="d-flex align-items-center">
                                                            <i className="ki-duotone ki-profile-circle fs-2 me-2">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                                <span className="path3"></span>
                                                            </i>{intl.formatMessage({ id: "ORDER.FIELD.CUSTOMER" })}</div>
                                                    </td>
                                                    <td className="fw-bold text-end">
                                                        <div className="d-flex align-items-center justify-content-end">
                                                            <button onClick={() => navigate(`/user-management/users/${order.user.id}`)} className="btn btn-link text-gray-600 text-hover-primary">{order.user.name} {order.user.surname}</button>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted">
                                                        <div className="d-flex align-items-center">
                                                            <i className="ki-duotone ki-sms fs-2 me-2">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>{intl.formatMessage({ id: "ORDER.FIELD.EMAIL" })}</div>
                                                    </td>
                                                    <td className="fw-bold text-end">
                                                        <a href="#" className="text-gray-600 text-hover-primary">{order.user.email}</a>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted">
                                                        <div className="d-flex align-items-center">
                                                            <i className="ki-duotone ki-phone fs-2 me-2">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>{intl.formatMessage({ id: "ORDER.FIELD.PHONE" })}</div>
                                                    </td>
                                                    <td className="fw-bold text-end">{order.user.phoneCode} {order.user.phone}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <PolicyChecker policies={[enumPolicies.InvoiceRead, enumPolicies.InvoiceEdit, enumPolicies.InvoiceWrite]}>
                                    {renderDocuments()}
                                </PolicyChecker>
                            </div>
                        </div>
                        <div className="tab-content">
                            {renderSummary()}
                            <PolicyChecker policies={[enumPolicies.OrderAdmin, enumPolicies.OrderPersonnel]}>
                                {renderImages()}
                                {renderHistory()}
                            </PolicyChecker>
                        </div>
                    </div>
                </div>
            </div>

            <SystemPolicyChecker policyId={enumSystemPolicyType.OrderContent}>
                {renderContentModal()}
                {renderReplaceContentModal()}
            </SystemPolicyChecker>
            {renderCalendarDataPickerModal()}

            {loading && <Loader />}
        </>
    );
};

const mapStateToProps = state => {
    return {
        order: state.Order.order,
        items: state.Order.items,
        productList: state.Product.productList,
        statusList: state.Order.statusList,
        historyList: state.Order.historyList,
        modalLoading: state.Product.loading,
        images: state.Order.images,
        uploadedImageId: state.Order.uploadedImageId,
        loading: state.Order.loading,
        success: state.Order.success,
        error: state.CalendarEvent.error
    };
};

const mapActionsToProps = {
    clearState, getOrder, putOrder, patchOrder, getOrderItems, patchOrderContentStatus, getProductList, putOrderContent,
    deleteOrderContent, postOrderContent, getStatus, postStatus, getHistory, getImages, uploadImage, deleteImage,
    getCalendarEvent, patchCalendarEvent, postCalendarEvent, replaceOrderContent
}

export default connect(mapStateToProps, mapActionsToProps)(Order)
